import type { ExceptionField } from '@/api/cockpit';

export function isDateField(field: ExceptionField): boolean {
  return field.key === 'requested_delivery_date' || field.key === 'requested_ship_date';
}
